const ERRO_TRABALHO_LABELS = {
    BLUETOOTH_DESABILITADO: 'Bluetooth desabilitado',
    BLUETOOTH_DESCONECTADO: 'Bluetooth desconectado',
    SAFRAJET_DESCONECTADO: 'SafraJet desconectado',
    TRABALHANDO_MODO_LIMPEZA: 'Trabalhando com modo limpeza ativado',
    MODO_LIMPEZA_ATIVO: 'Modo limpeza ativo',
    LIMPEZA_FINALIZANDO: 'Limpeza finalizando',
    APLICACAO_DIRETA: 'Aplicação direta',
    PURGO_ATIVO: 'Purgo ativo',
    GPS_VELOCIDADE_ALVO_PULV: 'GPS sem fix — velocidade alvo (pulverização)',
    VALVULA_1_DESCONECTADA: 'Válvula 1 desconectada',
    VALVULA_2_DESCONECTADA: 'Válvula 2 desconectada',
    VALVULAS_DESCONECTADAS: 'Válvulas desconectadas',
    PRESSAO_ALTA: 'Pressão alta',
    PRESSAO_BAIXA: 'Pressão baixa',
    PRESSAO_ALTA_S1: 'Pressão alta — sessão 1',
    PRESSAO_ALTA_S2: 'Pressão alta — sessão 2',
    PRESSAO_ALTA_AMBAS_SESSOES: 'Pressão alta — ambas sessões',
    PRESSAO_BAIXA_S1: 'Pressão baixa — sessão 1',
    PRESSAO_BAIXA_S2: 'Pressão baixa — sessão 2',
    PRESSAO_BAIXA_AMBAS_SESSOES: 'Pressão baixa — ambas sessões',
    PRESSAO_NAO_AUMENTA_TODAS: 'Pressão não está aumentando nas sessões',
    PRESSAO_NAO_AUMENTA_S1: 'Pressão não está aumentando — sessão 1',
    PRESSAO_NAO_AUMENTA_S2: 'Pressão não está aumentando — sessão 2',
    PRESSAO_NAO_CAI_TODAS: 'Pressão não está caindo nas sessões',
    PRESSAO_NAO_CAI_S1: 'Pressão não está caindo — sessão 1',
    PRESSAO_NAO_CAI_S2: 'Pressão não está caindo — sessão 2',
    PRESSAO_COMPORTAMENTO_INESPERADO_TODAS_SECOES: 'Comportamento inesperado de pressão em todas seções',
    PRESSAO_QUEDA_INESPERADA: 'Queda inesperada de pressão',
    PRESSAO_AUMENTO_INESPERADO: 'Aumento inesperado de pressão',
    NIVEL_BAIXO: 'Nível baixo',
    SEM_FLUXO_SECOES: 'Sem fluxo nas seções',
    MOTOR_1_FALHAS: 'Motor 1 apresentando falhas',
    MOTOR_2_FALHAS: 'Motor 2 apresentando falhas',
    AGITADOR_FALHAS: 'Agitador com falhas',
    BOMBA_TRANSFERENCIA_FALHAS: 'Bomba de transferência com falhas',
    SENSOR_PRESSAO_1_DESCONECTADO: 'Sensor de pressão 01 desconectado',
    SENSOR_PRESSAO_2_DESCONECTADO: 'Sensor de pressão 02 desconectado',
    SENSORES_PRESSAO_DESCONECTADOS: 'Sensores de pressão desconectados',
    POTENCIA_BOMBA_1_ACIMA: 'Potência da bomba 1 acima do esperado',
    POTENCIA_BOMBA_1_ABAIXO: 'Potência da bomba 1 abaixo do esperado',
    POTENCIA_BOMBA_2_ACIMA: 'Potência da bomba 2 acima do esperado',
    POTENCIA_BOMBA_2_ABAIXO: 'Potência da bomba 2 abaixo do esperado',
    TEMPERATURA_ALTA: 'Temperatura alta',
    SENSOR_TEMPERATURA_DESCONECTADO: 'Sensor de temperatura desconectado',
    FALHA_LEITURA_DADOS: 'Falha na leitura dos dados',
    SENSORES_SEMENTE_DESCONECTADOS: 'Sensores de semente desconectados',
    SENSORES_ADUBO_DESCONECTADOS: 'Sensores de adubo desconectados',
    SENSORES_SEMENTE_HUB_DESCONECTADO: 'Sensores de semente desconectados do hub',
    SENSORES_ADUBO_HUB_DESCONECTADO: 'Sensores de adubo desconectados do hub',
    TRABALHO_PARADO: 'Trabalho parado',
    GPS_SINAL_FRACO: 'Sinal fraco de GPS',
    GPS_SEM_SINAL: 'GPS sem sinal',
    FLUXO_SEMENTES_INESPERADO: 'Fluxo de sementes inesperado',
    FLUXO_ADUBO_INESPERADO: 'Fluxo de adubo inesperado',
    SEMENTES_SEM_FLUXO: 'Sem fluxo de sementes',
    SEMENTES_SENSOR_DESCONECTADO: 'Sensor de semente desconectado',
    SEMENTES_HUB_DESCONECTADO: 'Sensores de semente desconectados do hub (linha)',
    SEMENTES_ACIMA_PERMITIDO: 'Falha acima do permitido (sementes)',
    SEMENTES_ABAIXO_PERMITIDO: 'Falha abaixo do permitido (sementes)',
    ADUBO_SEM_FLUXO: 'Sem fluxo de adubo',
    ADUBO_SENSOR_DESCONECTADO: 'Sensor de adubo desconectado',
    ADUBO_HUB_DESCONECTADO: 'Sensores de adubo desconectados do hub (linha)',
    VELOCIDADE_MAXIMA_EXCEDIDA: 'Velocidade máxima excedida',
    SIMULACAO_ATIVA: 'Em simulação',
};

export function getErroTrabalhoLabel(codigo) {
    if (!codigo) return '';
    return ERRO_TRABALHO_LABELS[codigo] || codigo.replace(/_/g, ' ').toLowerCase();
}

export function collectErrosUnicosFromCoords(histCoords) {
    if (!Array.isArray(histCoords)) {
        return [];
    }
    const codigos = new Set();
    histCoords.forEach((coord) => {
        const erros = coord?.erros_ativos;
        if (Array.isArray(erros)) {
            erros.forEach((codigo) => {
                if (codigo) {
                    codigos.add(codigo);
                }
            });
        }
    });
    return Array.from(codigos).sort((a, b) =>
        getErroTrabalhoLabel(a).localeCompare(getErroTrabalhoLabel(b), 'pt-BR')
    );
}

export default ERRO_TRABALHO_LABELS;
